import { FC, useState, ChangeEvent } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery, useMutation } from 'react-query';
import { TextField, Input, IconButton, InputAdornment, Button } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react-lite';

export const LDAPCredentials: FC = observer(() => {
  const classes = useStyles();

  const {
    ldapStore: { credentials, getCredentials, updateCredentials, getPassword, passwords },
    userStore: { user, updateDomain },
    notificationStore: { openNotification },
  } = useStore();
  const updateDomainRequest = useMutation('updateDomainRequest', updateDomain, {
    onSuccess: (e) => {
      return openNotification('success', 'Successfully Updated');
    },
    onError: ({ message }: Error) => openNotification('error', message ? message : 'Something went wrong'),
  });

  const getCredentialsReq = useQuery('getCredentialsReq', () => getCredentials(), {});
  const getPasswordRequest = useMutation('getPasswordRequest', getPassword, {
    onSuccess: () => {
      openNotification('success', 'Successfully Updated');
    },
    onError: ({ message }: Error) => openNotification('error', message ? message : 'Something went wrong'),
  });

  const onSubmit = () => {
    getPasswordRequest.mutate();
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hostName, setHostName] = useState<string>(credentials?.domain.split('-ldap.easyidentity.co')[0] as string);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const updateCredentialsReq = useMutation((password: string) => updateCredentials(password), {
    mutationKey: 'logoutReq',
    onSuccess: () => openNotification('success', 'Successfully updated.'),
    onError: () => openNotification('error', 'Something went wrong'),
  });

  useAppPreloader(
    getCredentialsReq.isFetching ||
      updateCredentialsReq.isLoading ||
      updateDomainRequest.isLoading ||
      getPasswordRequest.isLoading
  );

  return !getCredentialsReq.isFetching ? (
    <>
      <div style={user?.promptMessage === true ? { cursor: 'not-allowed' } : {}} className={classes.container}>
        <Grid container className={classes.row}>
          <p className={classes.title}>Region:</p>
          <TextField
            // disabled={user?.promptMessage === true ? true : false}
            disabled
            className={classes.desc}
            key='region'
            placeholder='Region'
            value={`${credentials?.region}(${credentials?.city})`}
          />
        </Grid>
        <Grid container className={classes.row}>
          <p className={classes.title}>Host:</p>
          <TextField
            disabled={true}
            className={classes.desc}
            key='host'
            placeholder='Host'
            InputProps={{
              endAdornment: <InputAdornment position='end'>-ldap.easyidentity.co</InputAdornment>,
            }}
            value={credentials?.domain.split('-ldap.easyidentity.co')[0]}
            onChange={(event: ChangeEvent<{ value: unknown }>) => {
              setHostName(event.target.value as string);
            }}
          />
        </Grid>
        <Grid container className={classes.row}>
          <p className={classes.title}>IP address:</p>
          <TextField
            className={classes.desc}
            key='ipAddress'
            disabled
            placeholder='IP Address'
            value={credentials?.ip}
          />
        </Grid>
        <Grid container className={classes.row}>
          <p className={classes.title}>BaseDN:</p>
          <TextField className={classes.desc} key='baseDn' disabled placeholder='BaseDn' value={credentials?.baseDn} />
        </Grid>
        <Grid container className={classes.row}>
          <p className={classes.title}>Port:</p>
          <TextField className={classes.desc} key='port' disabled placeholder='Port' value={credentials?.port} />
        </Grid>
        <Grid container className={classes.row}>
          <p className={classes.title}>UserDN:</p>
          <TextField
            className={classes.desc}
            key='username'
            disabled
            placeholder='Username'
            value={credentials?.username}
          />
        </Grid>
        <Grid container className={classes.row}>
          <p className={classes.title}>Password:</p>
          <Input
            className={classes.desc}
            disabled={true}
            readOnly
            type={showPassword ? 'text' : 'password'}
            endAdornment={
              user?.promptMessage !== true && (
                <InputAdornment position='end'>
                  <IconButton aria-label='toggle password visibility' onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }
            key='password'
            placeholder='Password'
            value={passwords?.password === undefined ? credentials?.password : passwords?.password}
          />
          <Button style={{ marginLeft: '20px' }} variant='outlined' onClick={onSubmit}>
            Generate Password
          </Button>
        </Grid>
      </div>
    </>
  ) : null;
});
